import { ColorLike } from "ol/colorlike";
import { Style, Text, Fill, Stroke } from "ol/style"
import { IconColours } from "./Colours"
import WaypointFeature from "./WaypointFeature"
import { WaypointIconSet } from "./WaypointIconSet";

/*
 * Constructs and manages the Styles drawn as Waypoint icons.
 */
export class WaypointIcon {

    public static DEFAULT_ICON = "mdi-map-marker" 
    public static DEFAULT_COLOUR = "Black"

    // use a different colour when the waypoint is "selected" (ie open in the waypoint 
    // editor panel), ideally a colour that is different from any other [unselected] waypoint

    // Rather than generate styles for all icons in all possible 
    // colours, create them as-required and cache them for re-use
    private static cache: Map<string, Style>;

    /*
     * Construct (or retrieve from cache) a Style for drawing a named icon 
     * in a given colour, optionally highlighted as the "selected" waypoint
     */
    private static icon (iconName: string, colourName: string, isSelected: boolean): Style {
        
        // Fall back to defaults if we dont recognise the icon name or colour name
        if (!iconName || !WaypointIconSet[iconName]) iconName = WaypointIcon.DEFAULT_ICON   
        if (!colourName || !IconColours[colourName]) colourName = this.DEFAULT_COLOUR
        const colour = IconColours[colourName] as ColorLike

        if (!this.cache) this.cache = new Map<string, Style>();
        const key = iconName+colour+isSelected;
        if (!WaypointIcon.cache.has(key)) {
            const icon = WaypointIconSet[iconName]
            const iconStyle = new Style({
                text: new Text({
                    fill: new Fill({ color: colour }),
                    stroke: new Stroke({ color : 'white', width : icon.pad }),
                    text: String.fromCodePoint(icon.codePoint), 
                    font: isSelected ? '51px "Material Design Icons"' : '35px "Material Design Icons"',
                    offsetX: icon.xoffs, 
                    offsetY: icon.yoffs + (isSelected ? -8 : 0)
                })
            })
            WaypointIcon.cache.set(key, iconStyle)
        }

        return WaypointIcon.cache.get(key) as Style
    }

    /*
     * Fetch the Style for drawing the given waypoint
     */
    static iconFor(waypoint: WaypointFeature, isSelected = false): Style {
        return WaypointIcon.icon(waypoint.props.icon, waypoint.props.colour, isSelected)
    }

}